import { render, staticRenderFns } from "./AddItemForm.vue?vue&type=template&id=08ca9011&"
import script from "./AddItemForm.vue?vue&type=script&lang=js&"
export * from "./AddItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports